<template>
  <v-container fluid pa-0 v-if="$hasMatchingTenantRoles(['tenant_admin'])">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="start" justify="center" no-gutters>
          <v-col cols="12" md="5" class="pt-md-5">
            <div class="image-holder">
              <div class="grey lighten-5 rounded-circle" style="width: 100%; height: 100%">
                <v-slide-x-transition>
                  <v-row v-if="imageIsLoaded" align="start" class="fill-height" justify="center" no-gutters>
                    <img src="img/undraw_maker_launch_re_rq81.svg" style="height: 80%" />
                  </v-row>
                </v-slide-x-transition>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="7">
            <dismiss-onboarding-button />
            <div class="text-left">
              <div class="title text-sm-h5 font-weight-bold mt-5 mb-5">
                {{ $t('onboarding.lets_get_started') }}
              </div>
              <div class="subtitle-2 text-sm-subtitle-1">{{ $t('onboarding.short_introduction') }}</div>
              <div class="subtitle-2 text-sm-subtitle-1 mt-4">{{ $t('onboarding.short_introduction2') }}</div>
              <div>
                <basic-button class="mt-10" color="primary" @click="goToNextStep" outlined>
                  <v-icon left>mdi mdi-arrow-right</v-icon>
                  {{ $t('onboarding.lets_start') }}
                </basic-button>
              </div>
              <div class="text-body-2 text-sm-body-1 primary--text text--darken-1 mt-10">
                {{ $t('onboarding.dont_worry_this_wont_take_long') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <img src="img/undraw_maker_launch_re_rq81.svg" style="display: none" @load="imageIsLoaded = true" />
  </v-container>
</template>

<script>
import BasicButton from '@/components/BasicButton';
import DismissOnboardingButton from '@/components/Tenant/Onboarding/DismissOnboardingButton';
export default {
  name: 'Introduction',
  components: { DismissOnboardingButton, BasicButton },
  data() {
    return {
      imageIsLoaded: false,
    };
  },
  methods: {
    goToNextStep() {
      this.$emit('next-step');
    },
  },
};
</script>

<style lang="scss" scoped>
.image-holder {
  position: relative;
  margin: auto;
  width: 245px;
  height: 245px;
}

@media screen and (min-width: 1500px) {
  .image-holder {
    width: 285px;
    height: 285px;
  }
}
</style>
